import { render, staticRenderFns } from "./NuevoJugador.vue?vue&type=template&id=3d5980ef"
import script from "./NuevoJugador.vue?vue&type=script&lang=js"
export * from "./NuevoJugador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports